import { defaultsPlugin } from '../defaults';
import { commonServicesPlugin } from '../common-services';
import { viewerLocationPlugin } from '../viewer-location';
import { viewerNavigationPlugin } from '../viewer-navigation';
import { editorLocationPlugin } from '../editor-location';
export function viewerPlugin(flowApi, config) {
  const inMemory = (config == null ? void 0 : config.inMemory) ?? false;
  return function (router) {
    router.plugin(commonServicesPlugin());
    router.plugin(defaultsPlugin(flowApi));
    router.plugin(inMemory ? editorLocationPlugin(flowApi) : viewerLocationPlugin(flowApi));
    router.plugin(viewerNavigationPlugin(flowApi));
    return {
      name: 'WixUIRouterViewer'
    };
  };
}
//# sourceMappingURL=plugin.js.map